import { render } from "./AplicarFormacaoPrecoModal.vue?vue&type=template&id=50beb5ba&scoped=true&ts=true"
import script from "./AplicarFormacaoPrecoModal.vue?vue&type=script&lang=ts"
export * from "./AplicarFormacaoPrecoModal.vue?vue&type=script&lang=ts"

import "./AplicarFormacaoPrecoModal.vue?vue&type=style&index=0&id=50beb5ba&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50beb5ba"]])

export default __exports__